import { useEffect } from "react";

const SITE = "Easy Drive Car Rental";
const BASE_URL = "https://easydrivecarrental.com";
const MANAGED_ID = "page-jsonld";

export function useSEO({ title, description, path = "", jsonLd = null, noindex = false }) {
  const jsonLdStr = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    const fullTitle = title && title.includes("Easy Drive") ? title : title ? `${title} | ${SITE}` : null;
    if (fullTitle) document.title = fullTitle;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
    const robots = document.querySelector('meta[name="robots"]');
    if (robots) robots.setAttribute("content", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
    if (path) {
      const link = document.querySelector('link[rel="canonical"]');
      if (link) link.setAttribute("href", `${BASE_URL}${path}`);
      const og = document.querySelector('meta[property="og:url"]');
      if (og) og.setAttribute("content", `${BASE_URL}${path}`);
      const ogt = document.querySelector('meta[property="og:title"]');
      if (ogt && fullTitle) ogt.setAttribute("content", fullTitle);
      const ogd = document.querySelector('meta[property="og:description"]');
      if (ogd && description) ogd.setAttribute("content", description);
      const twt = document.querySelector('meta[name="twitter:title"]');
      if (twt && fullTitle) twt.setAttribute("content", fullTitle);
      const twd = document.querySelector('meta[name="twitter:description"]');
      if (twd && description) twd.setAttribute("content", description);
    }
    const prev = document.getElementById(MANAGED_ID);
    if (prev) prev.remove();
    if (jsonLdStr) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = MANAGED_ID;
      s.text = jsonLdStr;
      document.head.appendChild(s);
    }
    return () => {
      const el = document.getElementById(MANAGED_ID);
      if (el) el.remove();
    };
  }, [title, description, path, jsonLdStr, noindex]);
}
